import { useFormikContext } from "formik";
import { useEffect } from "react";

const ErrorFocusForm = () => {
    const { errors, isSubmitting, isValidating } = useFormikContext();

    useEffect(() => {
        if (isSubmitting && !isValidating) {
            const firstError = Object.keys(errors)[0];


            const element =
                document.querySelector(`[name="${firstError}"]`) ||
                document.querySelector(
                    `[data-field="${firstError}"]`
                );

            element?.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        }
    }, [errors, isSubmitting, isValidating]);

    return null;
};

export default ErrorFocusForm;